module.exports = __webpack_public_path__ + "static/media/Krombacher-SerifDemiItalic.bb1f484c.otf";